import { AxiosResponse } from 'axios';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { getCertificates } from 'services/claimsService';
import { ApplicationState } from 'store/store.inteface';
import { ApiResponse } from 'types/ApiResponse';
import { SagasAction } from 'types/SagasAction';

import { setCertificatesAction, setError } from './actions';
import { CERTIFICATES_TYPES, Certificates, GetCertificates } from './types';

export function* setCertificatesSaga({
  payload,
}: SagasAction<GetCertificates>) {
  yield put(setError(null));
  try {
    const { cpId } = yield select(
      (state: ApplicationState) => state.storesContext,
    );

    const { data }: AxiosResponse<ApiResponse<Certificates>> = yield call(
      getCertificates,
      cpId,
      payload,
    );
    yield put(setCertificatesAction(data));
  } catch (error) {
    if (error.response && error.response.status === 404) {
      yield put(setError(error.response.data.reason));
    } else {
      console.log(error);
    }
  }
}

export default all([
  takeLatest(CERTIFICATES_TYPES.GET_CERTIFICATES_REQUEST, setCertificatesSaga),
]);
